import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const Get_M_ELEC_WardWiseToken_SelectAPI = createAsyncThunk("Get_M_ELEC_WardWiseToken_Select", async ({ data }) => {
    const {
        M_WardID,
        token,
        M_UserID,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    url = `${BaseUrl}/Electrical/Get_M_ELEC_WardWiseToken_Select?M_WardID=${M_WardID}&Flag=${Flag}&M_UserID=${M_UserID}`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result?.code >= 200 && result?.code <= 300 && result?.data && result?.data?.table.length > 0) {
                return result
            } else {
                return result
            }
        })
        .catch((err) => {
            console.log("Error:", err)
            return err
        })
})

const Get_M_ELEC_WardWiseToken_SelectSlice = createSlice({
    name: "Get_M_ELEC_WardWiseToken_Select",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_M_ELEC_WardWiseToken_SelectAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_M_ELEC_WardWiseToken_SelectAPI.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.isLoading = false;
            state.tableData = data;

        });
        builder.addCase(Get_M_ELEC_WardWiseToken_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_M_ELEC_WardWiseToken_SelectReducer = Get_M_ELEC_WardWiseToken_SelectSlice.reducer




export const Post_M_ELEC_WardWiseToken_InsertDataAPI = createAsyncThunk("Post_M_ELEC_WardWiseToken_InsertData", async ({ data }) => {
    const {
        M_ELEC_WardWiseTokenID,
        M_FinancialYearID,
        M_MonthID,
        M_WardID,
        Token,
        API,
        SessionID,
        DomainID,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (Flag == "Update") {
        formdata.append("M_ELEC_WardWiseTokenID", M_ELEC_WardWiseTokenID);
        formdata.append("M_WardID", M_WardID);
        formdata.append("Token", Token);
        formdata.append("SessionID", SessionID);
        formdata.append("DomainID", DomainID);
        formdata.append("M_UserID", M_UserID);
    } else {
        formdata.append("M_FinancialYearID", M_FinancialYearID);
        formdata.append("M_MonthID", M_MonthID);
        formdata.append("M_WardID", M_WardID);
        formdata.append("Token", Token);
        formdata.append("API", API);
        formdata.append("SessionID", SessionID);
        formdata.append("DomainID", DomainID);
        formdata.append("M_UserID", M_UserID);
    }

    var requestOptions = {
        method: Flag == "Update" ? 'PATCH' : 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (Flag == "Update") {
        url = `${BaseUrl}/Electrical/M_ELEC_WardWiseToken_Update`
    } else {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_WardWiseToken_Insert`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const Post_M_ELEC_WardWiseToken_InsertDataSlice = createSlice({
    name: "Post_M_ELEC_WardWiseToken_InsertData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Post_M_ELEC_WardWiseToken_InsertDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Post_M_ELEC_WardWiseToken_InsertDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Post_M_ELEC_WardWiseToken_InsertDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const Post_M_ELEC_WardWiseToken_InsertDataReducer = Post_M_ELEC_WardWiseToken_InsertDataSlice.reducer

// -----------------Delete API ---------------

export const M_ELEC_WardWiseToken_DeleteAPI = createAsyncThunk("M_ELEC_WardWiseToken_Delete", async ({ data }) => {
    const {
        M_ELEC_WardWiseTokenID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_ELEC_WardWiseTokenID", M_ELEC_WardWiseTokenID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Electrical/M_ELEC_WardWiseToken_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const M_ELEC_WardWiseToken_DeleteSlice = createSlice({
    name: "M_ELEC_WardWiseToken_Delete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_ELEC_WardWiseToken_DeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(M_ELEC_WardWiseToken_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(M_ELEC_WardWiseToken_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const M_ELEC_WardWiseToken_DeleteReducer = M_ELEC_WardWiseToken_DeleteSlice.reducer
